<template>
    <div>
        <v-progress-linear v-if="loadingTasks" :indeterminate="true" color="white"></v-progress-linear>
        <v-flex offset-xs1 xs10>
            <v-text-field outlined  dense class="pt-2" placeholder="Result ID/Participant Name" color="primary" clearable v-model="markSearchValue"
                          append-icon="mdi-search" hide-details single-line></v-text-field>
        </v-flex>
        <v-list>
            <v-list-item v-for="(asmt, asmtKey) in ASSESSMENTS" :key="asmtKey" @click="">
                <v-list-item-content @click="handleSelectAssessment(asmt, asmtKey)">
                    <v-list-item-title>{{asmtKey.split("_")[0]}}</v-list-item-title>
                    <v-list-item-subtitle>{{asmtKey.split("_")[1]}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  export default {
    name: 'ScoringTaskList',

    data () {
      return {
        selectedAssessment: {},
        loadingTasks: false,
        selectedParticipantName: '',
        selectedResultID: '',
      }
    },

    methods: {
      ...mapActions(['MARK_FETCH_SCORING_TASKS', 'MARK_FETCH_ANSWERS']),
      ...mapMutations(['SET_SELECTED_ASSESSMENT', 'SET_MARK_SEARCH_VALUE', 'SET_TASK', 'SELECT_RESULT', 'SELECT_PARTICIPANT']),
      handleSelectAssessment(asmt, asmtKey){
        console.dir(asmt)
        this.selectedResultID = asmtKey.split("_")[0];
        this.selectedParticipantName = asmtKey.split("_")[1];
        this.SELECT_RESULT(this.selectedResultID);
        this.SELECT_PARTICIPANT(this.selectedParticipantName);
        this.SET_SELECTED_ASSESSMENT(asmt);
        this.$emit('selected', asmt)
        this.SET_TASK('mark');
      }
    },

    computed: {
      ...mapGetters({
        ASSESSMENTS: 'GET_ASSESSMENTS',
        SEARCH_VALUE: 'GET_MARK_SEARCH_VALUE'
      }),
      markSearchValue: {
        get(){
          return this.SEARCH_VALUE
        },
        set(v){
          this.SET_MARK_SEARCH_VALUE(v);
        }
      }
    },

    /*    mounted () {
          this.MARK_FETCH_SCORING_TASKS().then(() => {
            this.loadingTasks = false;
          })
        }*/
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .progress-linear {
        margin-top: 0px;
    }
</style>
